import React from "react";
import SeoCtaLink from "@components/SeoCtaLink";
import { RESUME_TAILOR_LISTING_URL } from "@src/config/resumeTailor";

export default function ResumeTailorSection() {
  if (!RESUME_TAILOR_LISTING_URL) return null;
  return (
    <section id="resume-tailor" aria-labelledby="resume-tailor-title" className="bg-indigo-50 px-6 py-14">
      <div className="mx-auto max-w-4xl">
        <p className="font-semibold text-indigo-700">LifeShack Resume Tailor for ChatGPT</p>
        <h2 id="resume-tailor-title" className="mt-3 text-3xl font-bold text-gray-900">
          Tailor your resume to a job description in ChatGPT
        </h2>
        <p className="mt-4 text-lg leading-8 text-gray-700">
          Bring your complete resume text and a job description. ChatGPT proposes role-specific edits;
          LifeShack gives you a private review page to compare the original and suggested wording,
          accept or reject each change, or write your own replacement before downloading a PDF.
        </p>
        <ol className="mt-6 list-decimal space-y-3 pl-6 text-gray-700">
          <li>Connect your account and ask: “Tailor my resume to this job and show me the changes.”</li>
          <li>Open the review link and check your experience, names, dates, skills and results.</li>
          <li>Download the reviewed PDF. Ask to save a named version when you want to return to it.</li>
        </ol>
        <p className="mt-5 text-gray-700">
          Drafts expire after 7 days; saved versions after 90 days. You can delete them sooner.
          PDFs use a simple Latin-script layout and retain the reviewed text across as many pages as needed.
          This document-review workflow does not submit applications and is separate from Auto Apply.
          No resume tool can guarantee interviews or an employer’s screening result.
        </p>
        <SeoCtaLink href={RESUME_TAILOR_LISTING_URL} pageType="resume" placement="resume_tailor_plugin"
          action="open_plugin" className="mt-6 inline-block rounded-lg bg-indigo-700 px-6 py-3 font-semibold text-white">
          Open LifeShack Resume Tailor
        </SeoCtaLink>
      </div>
    </section>
  );
}
